<template>
  <div class="login" >
    <section class="content loginPageWrap">
        <div class="loginPageWrapMain">
            <div class="img">
                <img src="../../../static/images/bigbigbig.png" alt="">
            </div>
            <div>
                <p class="pText">
                    专家登录
                </p>
            </div>
            <div class="yahei">
                <div class="hd" id="login1Main">
                    <a-button :type="primary?'primary':''" @click="primary = !primary" style="width:190px;height: 36px;margin: 10px 24px 0 0;">
                        继教网账号登录
                    </a-button>
                    <a-button :type="primary?'':'primary'" @click="primary = !primary" style="width:190px;height: 36px;">
                        大赛专家账号登录
                    </a-button>
                    <a-input ref="userNameInput" size="large" v-model="userName" placeholder="请输入您的账号" class="userNameInput" style="margin:25px 0 0;">
                        <span slot="prefix" style="">
                            <a-icon type="user" class="c9"/>
                            <span class="c9 f14">帐&nbsp;号：</span>
                        </span>
                    </a-input>
                    <a-input-password ref="password" size="large" v-model="password" placeholder="请输入密码" class="userNameInput" style="margin:25px 0;">
                        <span slot="prefix" style="">
                            <a-icon type="lock" class="c9"/>
                            <span class="c9 f14">密&nbsp;码：</span>
                        </span>
                    </a-input-password>
                    <!-- <div style="display: flex;justify-content: space-between;margin-top: 5px;">
                        <a-input placeholder="请输入验证码" size="large" style="margin-right: 20px;padding: 0;" v-model="code">
                        </a-input>
                        <img @click="getCodeImage" style="width: 90px;height: 40px;flex-shrink: 0" :src="codeUrl">
                    </div> -->
                    <br>
                    <div class="top30">
                        <button class="study-btn" style="width:100%;color:white;border-radius:3px;background-color:#1890FF;border: 0px;height: 42px;line-height: 40px;" :loading="loginLoading" @click="gologin">登&nbsp;&nbsp;&nbsp;&nbsp;录</button>
                    </div>
                </div>
            </div>
            <div class="loginDiv" v-if="getUserExpertList">
                <div>
                    <p>选择评审工作类型</p>
                    <p>
                        <a-button v-if="isCompetitionExpert" @click="isCompetitionExpertClick">
                            进入研训指导专家功能页
                        </a-button>
                    </p>
                    <p>
                        <a-button v-if="isCompetitionReviewExpert" @click="isCompetitionReviewExpertClick">
                            进入决赛评审功能页
                        </a-button>
                    </p>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
    import { message } from 'ant-design-vue';
    
  import axios from 'axios'
  import qs from 'qs';
  import notification from 'ant-design-vue/es/notification'
  import {constyjyp} from '../../core/constStatic';
  export default {
    data() {
      return {
        userName: '',
        password: '',
        Remenber: false,
        appId:'APPT047',
        loginFooter:'',
        loginLoading: false,
        kefuPhone: '',
        code: '',
        codeUrl: '',
        imageKey: '',
        primary: true,
        isCompetitionExpert: false,
        isCompetitionReviewExpert: false,
        getUserExpertList: false,
        thisjti: '',
        response: '',
      }
    },
    components: {
    },
    mounted () {
        this.getAppInfo();
        this.getCodeImage();
//        this.appUtils.getSignWithUrl();
        // console.log(this.appUtils.getSignWithUrl());
    },
      created(){
          console.log(this.$route.query)
      },
      methods: {
        getAppInfo(){
            this.axios.post(this.appUtils.getSignWithUrl(this.apis.home.baseServer + '/app-info/search'), {
                where: {
                    // domain_like: window.location.host
                    lmsDomain_like: "gzgl.gzteacher.com"
                    // lmsDomain_like: "gzts.ad.test.gdteacher.com"
                    // domain_like: 'http://172.16.146.184'
                }
            }, false, false).then(res => {
                console.log(res);
                let appId = 'APPT047';
                if (res.data.data && res.data.data.length > 0) {
                    appId = res.data.data[0].appId;
                    this.appId = appId;
                    this.loginFooter = res.data.data[0].loginFooter;
                    this.kefuPhone = res.data.data[0].kefuPhone;
                    this.appUtils.setLocalStorage('appinfo', res.data.data[0]);
                }

            }).catch(err => {
                console.log(err);
            });
        },
        getCodeImage(){
            this.axios.get(this.apis.system.getCodeImage).then(res => {
                this.codeUrl = res.data.data.imageURL;
                console.log(this.codeUrl);
                this.imageKey = res.data.data.imageCheckURL.split('checkImageCode/')[1];
                if (this.imageKey == ''){
                    message.warning('验证码获取失败');
                }
            }).catch(err => {
                console.log(err);
            });
        },
        isCompetitionExpertClick(){
            let tsgcAppInfo = JSON.parse(localStorage.getItem('appinfo'));
            let domainUrl = tsgcAppInfo.domain.split(',')[1];
            window.location.href = domainUrl + '/person/home?isCompetitionExpert='+(this.isCompetitionExpert ? 'Y' : 'N')+'&isCompetitionReviewExpert='+(this.isCompetitionReviewExpert ? 'Y' : 'N')+'&curExpertRouter=2&projectId=ed955989754540368d872aa59c04a6a0&trainType=5&jti='+this.response;
        },
        isCompetitionReviewExpertClick(){
            let tsgcAppInfo = JSON.parse(localStorage.getItem('appinfo'));
            let domainUrl = tsgcAppInfo.domain.split(',')[1];
            window.location.href = domainUrl + '/person/home/?isCompetitionExpert='+(this.isCompetitionExpert ? 'Y' : 'N')+'&isCompetitionReviewExpert='+(this.isCompetitionReviewExpert ? 'Y' : 'N')+'&curExpertRouter=1&projectId=ed955989754540368d872aa59c04a6a0&trainType=5&jti='+this.response;
        },
        // 登录
        gologin() {
            console.log(JSON.parse(localStorage.getItem('appinfo')));

            this.loginLoading = true;
            let url1= this.apis.system.gzExpertProjectLogin;
            let url=this.appUtils.getSignWithUrl(url1);
            let data={};
            if(this.username!==''&&this.password!==''){
                // data["grant_type"] = 'password';
                // data["client_id"] = 'resourceclient';
                // data["client_secret"] = 'resourcesecret';
                // data["username"] = this.appUtils.getRSAString(this.userName);
                // data["password"] = this.appUtils.getRSAString(this.password);
                data["username"] = this.userName;
                data["password"] = this.password;
                data['projectId'] = 'ed955989754540368d872aa59c04a6a0';
                data['appId'] = 'APPT047';
                if (this.primary){
                    data['loginType'] = 'jjw';
                } else {
                    data['loginType'] = 'pt';
                }

                // data['code'] = this.code;
                // data['imageKey'] = this.imageKey;
                
                this.axios.post(url,qs.stringify(data)).then((response) => {
                    if(response.data.status === 0){
                        this.thisjti = response.data.data;
                        
                        axios({ //换用户信息
                            method: 'get',
                            url: this.apis.system.checkToken + response.data.data //动态获取
                            // url: this.apis.system.checkToken + '7828062793624978baafcf9ad1d5a369' //动态获取
                            
                        }).then((res) => {
                            if (res.data.status == 0) {
                                
                                

                                this.axios.get(this.appUtils.getSignWithUrl(this.apis.system.getUserExpertList)+'&projectId=ed955989754540368d872aa59c04a6a0&userId='+res.data.data.x_userId).then(res1 => {
                                    console.log(res1);
                                    console.log(res1.data.data.isCompetitionExpert);
                                    if (res1.data.data.isCompetitionExpert == 'N' && res1.data.data.isCompetitionReviewExpert == 'N'){
                                        notification.error({
                                            message: '错误',
                                            description: '登录错误，非专家账号'
                                        })
                                        this.getUserExpertList = false;
                                    } else {
                                            // let tsgcAppInfo = JSON.parse(localStorage.getItem('appinfo'));
                                            //     let domainUrl = tsgcAppInfo.domain.split(',')[1];
                                            // if (res1.data.data.isCompetitionExpert == 'Y' && res1.data.data.isCompetitionReviewExpert == 'N'){
                                            //     // window.open(domainUrl + '/person/home?isCompetitionExpert='+(this.isCompetitionExpert ? 'Y' : 'N')+'&isCompetitionReviewExpert='+(this.isCompetitionReviewExpert ? 'Y' : 'N')+'&curExpertRouter=2&projectId=ed955989754540368d872aa59c04a6a0&trainType=5&jti='+this.response);
                                            //     window.location.href = domainUrl + '/person/home?isCompetitionExpert='+(this.isCompetitionExpert ? 'Y' : 'N')+'&isCompetitionReviewExpert='+(this.isCompetitionReviewExpert ? 'Y' : 'N')+'&curExpertRouter=2&projectId=ed955989754540368d872aa59c04a6a0&trainType=5&jti='+response.data.data;
                                            //     return false;
                                            // } else if (res1.data.data.isCompetitionExpert == 'N' && res1.data.data.isCompetitionReviewExpert == 'Y'){
                                            //     // window.open(domainUrl + '/person/home/?isCompetitionExpert='+(this.isCompetitionExpert ? 'Y' : 'N')+'&isCompetitionReviewExpert='+(this.isCompetitionReviewExpert ? 'Y' : 'N')+'&curExpertRouter=1&projectId=ed955989754540368d872aa59c04a6a0&trainType=5&jti='+this.response);
                                            //     window.location.href = domainUrl + '/person/home/?isCompetitionExpert='+(this.isCompetitionExpert ? 'Y' : 'N')+'&isCompetitionReviewExpert='+(this.isCompetitionReviewExpert ? 'Y' : 'N')+'&curExpertRouter=1&projectId=ed955989754540368d872aa59c04a6a0&trainType=5&jti='+response.data.data;
                                            //     return false;
                                            // }
                                        this.getUserExpertList = true;
                                        if (res1.data.data.isCompetitionExpert == 'Y'){
                                            this.isCompetitionExpert = true;
                                            this.response = response.data.data

                                            // 这里是进入区级指导专家评审页
                                            // 待补充
                                            // this.isCompetitionExpertClick();
                                            
                                        }
                                        if (res1.data.data.isCompetitionReviewExpert == 'Y'){
                                            this.isCompetitionReviewExpert = true;
                                            this.response = response.data.data

                                            // 这里是进入市级评审专家评审页
                                            // 待补充
                                            // this.isCompetitionReviewExpertClick();
                                            
                                        }
                                    }
                                }).catch(err => {
                                    console.log(err);
                                });




                            } else if (res.data.status == 1001) {
                                notification.error({
                                    message: '错误',
                                    description: '登录错误，重新登录'
                                })
                                // window.location.href = appUtils.getDomainUrl()+'/login';
                            }
                        }).catch((err) => {
                            notification.error({
                                message: '错误',
                                description: '登录错误，重新登录'
                            })
                            // window.location.href = appUtils.getDomainUrl()+'/login';
                        });


                        // // if (!(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,16}$/.test(this.password))){
                        // //     // 弱密码，需要重新设置密码
                        // //     this.$message({'message': '您所使用的密码为弱密码，请进行修改', 'type': 'error'});
                        // //     let that = this;
                        // //     let time = window.setTimeout(function (){
                        // //         that.$router.push({ path: '/changePwd?userId='+response.data.x_userId });
                        // //     },1000);
                        // //     return false;
                        // // }
                        // this.appUtils.setLocalStorage(this.constStatic.TOKEN_KEY,response.data.access_token);
                        // this.appUtils.setLocalStorage(this.constStatic.USER_INFO,response.data);
                        // // this.headPhoto = response.data.x_photo == '' ? this.headPhoto : response.data.x_photo;
                        // // this.realName = response.data.x_realName;
                        // // this.school = response.data.x_userDeptName;
                        // // this.showLogin = false;
                        // // alert('登录成功')
                        // console.log(response);
                        // // console.log(projectId);
                        // this.$router.push({path: '/'});
                    }else{
                        // this.$message({'message':response.data.message,'type':'error'});
                        message.warning(response.data.message);
                    }
                    this.loginLoading = false;
                }).catch((err)=>{
                    // alert('用户名或密码错误')
                    console.log(err);
                    this.loginLoading = false;
                })
            }
            else {
                alert('用户名或密码不能为空')
            }
        },
        openDislog(){
            this.$router.push({path: '/resetPwd'});
        }
    }
  }
</script>

<style lang="scss">
    @import 'http://css.ttcn.cn/common/v2/common.css';

    .loginDiv{
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 510px;
        height: 280px;
        background-color: white;
        border-radius: 15px;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-evenly;
        align-items: center;
    }
    .loginDiv > div{
        height: 86%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-evenly;
        align-items: center;
    }
    .loginDiv p{
        font-size: 20px;
    }
    .loginPageWrap{
        background: url('../../../static/images/bgbgbg.jpg');
        width: 100vw;
        height: 100vh;
        background-size: cover;
        background-position: center;
    }
    .loginPageWrapMain{
        position: fixed;
        top: 38%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .loginPageWrapMain .img{
        width: 700px;
        margin: 20px 0 0;
    }
    .loginPageWrapMain .img img{
        width: 100%;
    }
    .pText{
        color: white;
        font-size: 34px;
        text-align: center;
        font-weight: bold;
        letter-spacing:4px;
    }
    #login1Main{
        width: 405px;
        margin: auto;
    }
    #login1Main .userNameInput input{
        padding-left: 80px !important;
    }
    .c9{
        color: #999999;
    }
    .f12{
        font-size: 12px;
    }
    .f14{
        font-size: 14px;
    }
</style>
